import React from 'react'
import { useState, useEffect } from 'react'
import Searchbar from '../../../components/forms/searchbar'
import Item from './item'
import FormInput from '../../../components/forms/formInput'
import FormTextarea from '../../../components/forms/formTextarea'
import GreenButton from '../../../components/forms/greenButton'
import BlueButton from '../../../components/forms/blueButton'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ApiUrl from '../../../configTools/apiUrl'


const Location = () => {
  const User = JSON.parse(localStorage.getItem("user-info"));
  const [LocationList,setLocation] = useState([]);
  const [Filter,setFilter] = useState(LocationList);
  const get_admin_list = () =>{
    fetch(ApiUrl.API_URL_Location)
    .then(res=>res.json())
    .then(data =>{
      setLocation(data);
      setFilter(data);
    });
  }
  function filterFunction(value){
    if(value === ""){
        setFilter(LocationList);
    }
    else{
      const filtedLocation = LocationList.filter((obj)=>{
        return Object.values(obj)
        .join(" ").toLowerCase()
        .includes(value.toLowerCase());
      })
      setFilter(filtedLocation);
    }
  }
  const [id,setID] = useState('0');
  const [name,setName] = useState('');
  const [postalcode,setPostalcode] = useState('');
  const [remarks,setRemarks] = useState('');
  const [save,setSave] = useState('Save');

  function add_admin(){
    const toastid = toast.loading("Please wait ...",{ position: toast.POSITION.BOTTOM_CENTER});
    if(id === "0"){
      fetch(ApiUrl.API_URL_Location, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify({
            name : name,
            postalcode: postalcode,
            remarks : remarks
        })
      })
      .then(res=>res.json())
      .then(data =>{
        if(data.success){
          ResetFunction();
          get_admin_list();
          setTimeout(() => {
            toast.update(toastid, { render: "Added", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
          }, 500);
        }
        else{
          setTimeout(() => {
            toast.update(toastid, { render: data.responce, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
          }, 500);
        }
      });
    }
    else{
      fetch(ApiUrl.API_URL_LocationUpdate, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify({
            Id : id,
            name : name,
            postalcode: postalcode,
            remarks : remarks
        })
      })
      .then(res=>res.json())
      .then(data =>{
        if(data.success){
          ResetFunction();
          get_admin_list();
          setTimeout(() => {
            toast.update(toastid, { render: "Updated", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
          }, 500);
        }
        else{
          setTimeout(() => {
            toast.update(toastid, { render: data.responce, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
          }, 500);
        }
      });
    }
  }
  const ResetFunction = ()=>{
    setID("0"); setName(""); setRemarks(""); setPostalcode(""); setSave('Save');
  }
  useEffect(() => {
    get_admin_list();
  },[])
  return (
    <div className='admin_forms_main_container'>
      <div className='admin_forms_row'>
        <div className='admin_col_40'></div>
        <div className='admin_col_60'>
            <div className='admin_forms_container'>
              <FormInput Lable='Name' Type='text' Placeholder='Enter name' Value={name} setValue={setName}/>
              <FormInput Lable='Postal Code' Type='text' Placeholder='Enter postal code' Value={postalcode} setValue={setPostalcode}/>
              <FormTextarea Lable='Remarks' Placeholder='Enter remarks' Value={remarks} setValue={setRemarks}/>
              <div className='admin_forms_row'>
                <div className='admin_col_45'>
                  <GreenButton Value={save} Action={add_admin}/>
                </div>
                <div className='admin_col_10'></div>
                <div className='admin_col_45'>
                  <BlueButton Value='Reset' Action={ResetFunction}/>
                </div>
              </div>
            </div>
            <div className='form_table_container'>
              <Searchbar Filter={filterFunction}/>
              <table>
                <thead>
                    <tr className='form_item_row_container title'>
                    <td className='form_item_row_container_item' style={{width:'30%'}}>
                        <p>Name</p>
                    </td>
                    <td className='form_item_row_container_item' style={{width:'30%'}}>
                        <p>Postal Code</p>
                    </td>
                    <td className='form_item_row_container_item' style={{width:'40%'}}>
                        <p>Remarks</p>
                    </td>
                    </tr>
                </thead>
                <tbody>
                {
                  Filter.map((item)=>{
                    return(
                      <Item Obj = {item} setID = {setID} setName = {setName} setRemarks = {setRemarks} setPostalcode = {setPostalcode} setSave={setSave} key={item.id} />
                    );
                  })
                }
                </tbody>
              </table>
            </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  )
}

export default Location
